import * as z from "zod";

export const firstInstallOnboardingTeamRowSchema = z.object({
  teamId: z.string(),
  teamName: z.string().nullable(),
  storeUrl: z.string().nullable(),
  installedAt: z.string().nullable(),
  activeProducts: z.array(z.string()),
  orderCountLastYear: z.number().nullable(),
});

export type FirstInstallOnboardingTeamRow = z.infer<
  typeof firstInstallOnboardingTeamRowSchema
>;

export const getFirstInstallOnboardingTeams = {
  name: "getFirstInstallOnboardingTeams" as const,
  input: z.object({
    attributionSource: z.string().nullable().optional(),
    onboardingProduct: z.string().nullable().optional(),
    limit: z.number().int().min(1).max(500).optional(),
    offset: z.number().int().min(0).optional(),
  }),
  output: z.object({
    teams: z.array(firstInstallOnboardingTeamRowSchema),
    total: z.number().int().min(0),
    totalOrders: z.number().int().min(0),
  }),
};

export type GetFirstInstallOnboardingTeamsInput = z.infer<
  typeof getFirstInstallOnboardingTeams.input
>;

export type GetFirstInstallOnboardingTeamsOutput = z.infer<
  typeof getFirstInstallOnboardingTeams.output
>;
